module.exports = __webpack_public_path__ + "img/bill-outlined-grey.738945cb.svg";